import McBarChart from './McBarChart';

export default McBarChart;
